module.exports = __webpack_public_path__ + "img/icon-customer-card@3x.d077e7c8.png";